import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { EventDialogs } from '../../constants/Dialogs';

import TableView from '../Common/TableView';
import AddEntityActionButton from '../Common/AddEntityActionButton';
import EventAttendeeTableRow from './EventAttendeeTableRow';
import EventTrainersDialog from './EventTrainersDialog';
import EmailAttendeesDialog from '../Message/BulkEmailDialog';
import IconButton from 'material-ui/IconButton';

import InfoIcon from 'material-ui/svg-icons/action/info';
import SignOutIcon from 'material-ui/svg-icons/navigation/cancel';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import PersonIcon from 'material-ui/svg-icons/social/person';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import EventActions from '../../actions/EventActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';
import EventAttendeeStore from '../../stores/EventAttendeeStore';
import ModuleStore from '../../stores/ModuleStore';
import EventStore from '../../stores/EventStore';
import buildContextMenu from '../Common/BuildContextMenu';
import { toNumber } from '../../utils/StringUtils';
import { withId } from '../Common/Decorators';

const getMenuItems = (eventId) => [
    {
        link: `/dashboard/event/${eventId}`,
        icon: <InfoIcon />,
        label: 'Preview',
    },
    {
        link: `/dashboard/event/${eventId}/attendees`,
        icon: <PersonIcon />,
        label: 'Attendance',
    },
    {
        type: 'divider'
    },

    {
        link: '/logout',
        icon: <SignOutIcon />,
        label: 'Sign out',
    },
];

const defaultAttendance = (moduleId) => ({
    userId:     null,
    title:      null,
    firstName:  null,
    lastName:   null,
    moduleId
});

class EventAttendees extends Component {

    componentDidMount() {
        this.onEventChange = this.onEventChange.bind(this);
        this.onAddEvent = this.onAddEvent.bind(this);
        this.onRowSelection = this.onRowSelection.bind(this);
        this.openMessageDialog = this.openMessageDialog.bind(this);
        this.onSendMessages = this.onSendMessages.bind(this);

        EventActions.getAttendees(this.props.eventId, { role: 'trainer' });
        this.listeners = [
            EventStore.addListener(this.onEventChange),
            ModuleStore.addListener(() => this.setState({moduleId: (ModuleStore.getByEvent(this.props.eventId) || {}).id}))
        ];
        EventActions.getById(this.props.eventId);
        ModuleActions.getByEvent(this.props.eventId);
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        return (
            <TableView
                title={this.state.title}
                headers={['Trainer', 'Registered', '']}
                rows={this.state.attendees}
                decorator={EventAttendeeTableRow}
                backButton={true}
                isFetching={this.state.isFetching}
                multiSelectable={true}
                enableSelectAll={true}
                onRowSelection={this.onRowSelection}
                tableActions={this.getTableActions()}
                actions={buildContextMenu(getMenuItems(this.props.eventId), this.context.auth)}
            >
                <AddEntityActionButton onClick={() => DialogActions.open(EventDialogs.TRAINER_ADD, defaultAttendance(this.state.moduleId))} />
                {this.getDialog()}
            </TableView>
        );
    }

    getDialog() {
        switch (this.state.dialog) {
            case EventDialogs.TRAINER_ADD:
                return (<EventTrainersDialog onSave={this.onAddEvent} />);

            case EventDialogs.ATTENDEE_BULK_EMAIL:
                return (<EmailAttendeesDialog onSave={this.onSendMessages} />);

            default: break;
        }
    }

    getTableActions() {
        return [
            <IconButton
                key="mass_email"
                tooltip="Send message"
                disabled={this.state.selected.length === 0}
                onClick={this.openMessageDialog}
            >
                <EmailIcon />
            </IconButton>
        ];
    }


    onEventChange() {
        const event = EventStore.getById(this.props.eventId);
        if (!!event) {
            this.setState({title: ` ${event.name}: Trainers`});
        }
    }

    onAddEvent(draft) {
        if (!draft.userId) { return; } // guard: userId exists
        EventActions.addAttendance(this.props.eventId, draft);
    }

    openMessageDialog() {
        if (this.state.selected.length === 0) { return; } // guard
        let users;
        if (this.state.selected === 'all') {
            users = this.state.attendees;
        } else {
            users = this.state.attendees.filter((user, i) => this.state.selected.includes(i));
        }
        users = users.map(({userId, email, title, firstName, lastName}) => ({id: userId, email, name: `${title || ""} ${firstName || ""} ${lastName || ""}`.trim()}));
        DialogActions.open(EventDialogs.ATTENDEE_BULK_EMAIL, {users, subject: '', message: ''});
    }

    onSendMessages({subject, message, users}) {
        EventActions.sendEmail(this.props.eventId, subject, message, users);
    }

    onRowSelection(selected) {
        if (selected === this.state.selected) { return; } // guard
        this.setState({selected});
    }
}

EventAttendees.getStores = () => ([EventAttendeeStore, DialogStore]);
EventAttendees.calculateState = (prevState, {eventId}) => ({
    title: (!!prevState && prevState.title) || 'Trainers',
    selected: (!!prevState && prevState.selected) || [],
    isFetching: EventAttendeeStore.isFetching(),
    attendees: EventAttendeeStore.getTrainersByEvent(eventId),
    dialog: DialogStore.getOpenDialog(),
    moduleId: (!!prevState && prevState.moduleId) || null
});

EventAttendees.contextTypes = {
    auth:   PropTypes.object.isRequired
};

const getIds = ({routeParams}) => ({eventId: Number(routeParams.id)});

export default withId(Container.create(EventAttendees, {withProps: true}), getIds);
